import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card3 from "../Images/NewsFeeds/CO2Balance/a.jpg";
import Card1 from "../Images/NewsFeeds/CO2Balance/IMG_20220725_115040_246.jpg";

export function CO2balanceUganda() {
  return (
    <div className="art-page">
      <SEO
        title="Baseline KPT Surveys — CO2balance Uganda"
        description="In July 2022, CIRCODU conducted baseline Kitchen Performance surveys for CO2balance across districts in eastern and western Uganda, establishing pre-project fuel consumption data for carbon credit verification."
        keywords="CO2balance, baseline KPT, Kitchen Performance Test, carbon offset, cookstove Uganda, fuel consumption, carbon finance, emissions reduction, clean cooking, carbon project development, pre-intervention data, fuel use patterns, traditional stoves, carbon registries, CIRCODU, CO2balance baseline Uganda, KPT survey Uganda, cookstove monitoring Uganda, fuel consumption study Uganda, carbon offset projects Uganda"
        url="/Baseline-KPT-Surveys-CO2balance-Uganda"
        image={Card3}
        datePublished="2022-07-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Baseline KPT Surveys — CO2balance Uganda
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              July 01, 2022
            </div>
            <h1 className="art-title">
              Baseline KPT Surveys — CO2balance Uganda
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In July 2022, CIRCODU conducted baseline Kitchen Performance
                surveys for <strong>CO2balance</strong> across districts in
                eastern and western Uganda. CO2balance is a UK-based carbon
                offset project developer with a long-standing portfolio of
                improved cookstove and clean water programmes in East Africa,
                combining carbon finance with direct community development
                outcomes.
              </p>
              <p>
                Credible baseline data is the foundation of every carbon credit
                calculation. Without a rigorous, independently collected picture
                of fuel consumption before an intervention, it is impossible to
                calculate with confidence what emissions reductions a programme
                has achieved. CIRCODU's work for CO2balance provided exactly
                that foundation.
              </p>
              <img
                src={Card1}
                alt="CIRCODU researcher in the field"
                className="art-img"
              />
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>CIRCODU conducted structured baseline surveys documenting:</p>
              <ol>
                <li>
                  Cooking technologies and fuels used in participating
                  households.
                </li>
                <li>Cooking practices and meal preparation routines.</li>
                <li>
                  Daily quantities of cooking fuel consumed, measured directly
                  through Kitchen Performance Tests.
                </li>
              </ol>
              <p>
                The quantitative baseline data collected will serve as the
                benchmark against which future post-project measurements are
                compared to calculate verified emissions reductions — providing
                the credible, independently verified evidence that CO2balance
                requires for its carbon registry submissions.
              </p>
              <img
                src={Card3}
                alt="CIRCODU researcher in the field"
                className="art-img"
              />
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's baseline KPT survey
                services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
